import React, { useEffect, useState } from 'react';
import { db, doc, getDoc } from '../models/firebase';
import { useAudio } from '../context/AudioContext';
import SelectLanguage from './selectLanguage';
import NoQrView from './noqrView';
import LoadingView from './loadingView';
import Header from './Header';
import DetailAllergy from './DetailAllergy';
import './body.css'
import { VPS_BASE_URL } from "../constants";
import { environment } from '../environment';
import logo from '../assets/logo_text.png';
import playStoreLogo from '../assets/img/icon/playStore.png';
import appStoreLogo from '../assets/img/icon/appleStore.png';




// http://localhost:3000?qrCode=Dl1p0eeS5B1V9kHAR09k

function Body() {
  //const userId = "51pJ58i4RkR7OvM7tsSgLC4HqM63";
  //const qrCodeId ="PovkwpMmTQY885JyuA1O";
  let qrCodeId ="";
  const [cardId, setCardId] = useState(null);
  const [cardData, setCardData] = useState(null);

  const [allergies, setAllergies] = useState([]);
  const [alert, setAlert] = useState(null);
  const [templateImage, setTemplateImage] = useState(null);
  const [gridColumns, setGridColumns] = useState(3);

  const [flagUrl, setFlagUrl] = useState(null);


  const [userLanguageBrowser, setUserLanguage] = useState();

  const [languageTranslation, setLanguageTranslated] = useState();
  const [loading, setLoading] = useState(true);
  const[showPage, setShowPage] = useState();
  const [audioMain, setAudioMain] = useState('');
 
  const [iconAssets, setIconAssets] = useState({});
  const [showModalSelectLanguage, setShowModalLanguage] = useState(false);
  const [languageList, setLanguageList] = useState([]);
  const [showRealImages, setShowRealImages] = useState(false); // Toggle between icon and real images
  const [selectedAllergy, setSelectedAllergy] = useState(null); // For detail view


  const {playSound, stopSound, isPlayingRef } = useAudio();

  // Update grid layout based on number of allergies
  useEffect(() => {
    const length = allergies.length;

    if (length === 1) {
      setGridColumns(1); // Full width
    } else if (length === 2) {
      setGridColumns(2); // 2 columns
    } else if (length >= 3 && length <= 4) {
      setGridColumns(2); // 2 columns
    } else if (length > 4) {
      setGridColumns(3); // 3 columns
    }
  }, [allergies]);





const getAssets = async () => {
  if (environment.takeDataFrom === "LOCAL") {
    // Load icons from local assets
    const assets = {
      speaker: `/assets/img/icon/speaker.png`,
      warning: `/assets/img/icon/warning_yellow.png`,
      tableSet: `/assets/img/icon/tableSet.png`,
      picture: `/assets/img/icon/picture.png`,
    };
    setIconAssets(assets);
  } else {
    // Load icons from VPS
    const assets = {
      speaker: `${VPS_BASE_URL}/img/icon/speaker.png`,
      warning: `${VPS_BASE_URL}/img/icon/warning_yellow.png`,
      tableSet: `${VPS_BASE_URL}/img/icon/tableSet.png`,
      picture: `${VPS_BASE_URL}/img/icon/picture.png`,
    };
    setIconAssets(assets);
  }
}

// Get allergy image URL based on toggle state
const getAllergyImageUrl = (item) => {
  const baseName = item.imgUrl.replace('.png', '');
  if (showRealImages) {
    return `${baseName}_real.png`;
  }
  return item.imgUrl;
};

// Toggle between icon and real images
const toggleImageType = () => {
  setShowRealImages(!showRealImages);
};



  useEffect(() => {
  const fetchQrAndCard = async () => {
    // 1️⃣ Lire le qrCode dans l’URL
    const urlParams = new URLSearchParams(window.location.search);
    const qrCodeId = urlParams.get("qrCode");

    console.log("QR Code ID from URL:", qrCodeId);

    if (!qrCodeId) {
      setShowPage(false);
      setLoading(false);
      return;
    }

    try {
      // 2️⃣ Vérifier que le QR existe
      const qrRef = doc(db, "qrCodes", qrCodeId);
      const qrSnap = await getDoc(qrRef);

      if (!qrSnap.exists()) {
        setShowPage(false);
        setLoading(false);
        return;
      }

      // 3️⃣ Récupérer le cardId lié au QR
      const qrData = qrSnap.data();
      const cardId = qrData.cardId;
      setCardId(cardId);

      // 4️⃣ Charger la carte depuis "cards"
      const cardRef = doc(db, "cards", cardId);
      const cardSnap = await getDoc(cardRef);

      if (!cardSnap.exists()) {
        console.error("Card not found in Firebase");
        setShowPage(false);
        setLoading(false);
        return;
      }

      const card = cardSnap.data();

      
setCardData(card);
console.log("Card Data:", card);




const lang = (navigator.language || "en").substring(0, 2);

// Use LOCAL or VPS based on environment setting
if (environment.takeDataFrom === "LOCAL") {
  setFlagUrl(getTemplatePictureFromLocal('img/flags/' + lang + '.png'));
} else {
  setFlagUrl(`${VPS_BASE_URL}/img/flags/${lang}.png`);
}

setUserLanguage(lang);

// Charger données VPS avec l'objet card directement
// 🔥 Choisir LOCAL ou VPS
if (environment.takeDataFrom === "LOCAL") {
  const allergies = await fetchAllergiesFromLocal(card.allergyIds, lang);
  setAllergies(allergies);

  const alertInfo = await fetchAlertsFromLocal(
    card.alertAllergyTitleId,
    card.alertAllergyId,
    lang
  );
  setAlert(alertInfo);
  setAudioMain(alertInfo.audioUrl);

  setTemplateImage(getTemplatePictureFromLocal(card.pictureTemplateUrl));
} else {
  const allergies = await fetchAllergiesFromVps(card.allergyIds, lang);
  setAllergies(allergies);

  const alertInfo = await fetchAlertFromVps(
    card.alertAllergyTitleId,
    card.alertAllergyId,
    lang
  );
  setAlert(alertInfo);
  setAudioMain(alertInfo.audioUrl);

  setTemplateImage(getTemplatePicture(card.pictureTemplateUrl));
}

// Load icon assets
await getAssets();

// Load language list based on environment
if (environment.takeDataFrom === "LOCAL") {
  const languages = await fetchLanguagesFromLocal();
  setLanguageList(languages);
} else {
  const languages = await fetchLanguagesFromVps();
  setLanguageList(languages);
}

      // 5️⃣ Indiquer au composant que les données sont prêtes
      setShowPage(true);

    } catch (error) {
      console.error("Firebase error:", error);
      setShowPage(false);
    } finally {
      setLoading(false);
    }
  };

  fetchQrAndCard();
}, []);



const fetchAllergiesFromVps = async (allergyIds, lang) => {
  const res = await fetch(`${VPS_BASE_URL}/json/allergies.json`);
  const db = await res.json();

  // Retourner seulement les allergies de la carte
  const items = allergyIds.map(id =>
    db.find(a => String(a.id) === String(id) || a.image === id)
  );

  // Construire leur image + audio + traduction
  return items.map(a => ({
    id: a.id,
    name: a.name,
    translation: a.translation[lang],
    imgUrl: `${VPS_BASE_URL}/img/allergies/${a.image}.png`,
    audioUrl: `${VPS_BASE_URL}/audio/allergies/${a.image}/${lang.toLowerCase()}_${a.image}.mp3`
  }));
};



const fetchAlertFromVps = async (alertTitleId, alertTextId, lang) => {
  const resTitle = await fetch(`${VPS_BASE_URL}/json/alerts_title.json`);
  const titles = await resTitle.json();
  const titleObj = titles.find(t => String(t.id) === String(alertTitleId));

  const resAlert = await fetch(`${VPS_BASE_URL}/json/alerts.json`);
  const alerts = await resAlert.json();
  const alertObj = alerts.find(a => String(a.id) === String(alertTextId));

  return {
    title: titleObj.translation[lang],
    text: alertObj.translation[lang],
    audioUrl: `${VPS_BASE_URL}/audio/alert/${alertTextId}/${lang.toLowerCase()}_${alertTextId}.mp3`
  };
};





const getTemplatePicture = (url) =>
  `${VPS_BASE_URL}/${url.replace("assets/", "")}`;



// data from storage

const fetchAllergiesFromLocal = async (allergyIds, lang) => {
  const res = await fetch(`/assets/json/allergies.json`);
  const db = await res.json();

  // Retourner seulement les allergies de la carte
  const items = allergyIds.map(id =>
    db.find(a => String(a.id) === String(id) || a.image === id)
  );
  // Construire leur image + audio + traduction
  return items.map(a => ({
    id: a.id,
    name: a.name,
    translation: a.translation[lang],
    imgUrl: `/assets/img/allergies/${a.image}.png`,
    audioUrl: `/assets/audio/allergies/${a.image}/${lang.toLowerCase()}_${a.image}.mp3`
  }));
};


const fetchAlertsFromLocal = async (alertTitleId, alertTextId, lang) => {
  const resTitle = await fetch(`/assets/json/alerts_title.json`);
  const titles = await resTitle.json();
  const titleObj = titles.find(t => String(t.id) === String(alertTitleId));

  const resAlert = await fetch(`/assets/json/alerts.json`);
  const alerts = await resAlert.json();
  const alertObj = alerts.find(a => String(a.id) === String(alertTextId));

  return {
    title: titleObj.translation[lang],
    text: alertObj.translation[lang],
    audioUrl: `/assets/audio/alert/${alertTextId}/${lang.toLowerCase()}_${alertTextId}.mp3`
  };
};



const getTemplatePictureFromLocal = (url) =>
  `/assets/${url.replace("assets/", "")}`;


const fetchLanguagesFromLocal = async () => {
  const res = await fetch(`/assets/json/languages.json`);
  const languages = await res.json();

  return languages.map(lang => ({
    id: lang.id,
    language: lang.language,
    name: lang.name,
    languageTranslation: lang.languageTranslation,
    imgUrl: `/assets/img/flags/${lang.language}.png`,
    translationCardTitle: lang.translationCardTitle,
    translation: lang.translation
  }));
};

const fetchLanguagesFromVps = async () => {
  const res = await fetch(`${VPS_BASE_URL}/json/languages.json`);
  const languages = await res.json();

  return languages.map(lang => ({
    id: lang.id,
    language: lang.language,
    name: lang.name,
    languageTranslation: lang.languageTranslation,
    imgUrl: `${VPS_BASE_URL}/img/flags/${lang.language}.png`,
    translationCardTitle: lang.translationCardTitle,
    translation: lang.translation
  }));
};




  const handlePlaySound = () => {
    playSound(audioMain);
  };



  const openModalLanguage = () => {
    setShowModalLanguage(true);
  };

  const closeModalLanguage = () => {
    setShowModalLanguage(false);
  };

  const fetchAudioUrl = async (languageCode) => {
    try {
      if (environment.takeDataFrom === "LOCAL") {
        // Load from local assets - need to refetch alert data with new language
        if (!cardData) return;

        const alertInfo = await fetchAlertsFromLocal(
          cardData.alertAllergyTitleId,
          cardData.alertAllergyId,
          languageCode
        );
        setAlert(alertInfo);
        setAudioMain(alertInfo.audioUrl);

        // Update allergies with new language
        const updatedAllergies = await fetchAllergiesFromLocal(
          cardData.allergyIds,
          languageCode
        );
        setAllergies(updatedAllergies);
      } else {
        // Load from VPS - need to refetch alert data with new language
        if (!cardData) return;

        const alertInfo = await fetchAlertFromVps(
          cardData.alertAllergyTitleId,
          cardData.alertAllergyId,
          languageCode
        );
        setAlert(alertInfo);
        setAudioMain(alertInfo.audioUrl);

        // Update allergies with new language
        const updatedAllergies = await fetchAllergiesFromVps(
          cardData.allergyIds,
          languageCode
        );
        setAllergies(updatedAllergies);
      }
    } catch (error) {
      console.error('Error fetching audio URL:', error);
    }
  };
  
  

  const handleSelectLanguage = async (languageSelected) => {
    const newLang = languageSelected.language;
    setUserLanguage(newLang);
    setLanguageTranslated(languageSelected);

    // Update flag URL based on environment
    if (environment.takeDataFrom === "LOCAL") {
      setFlagUrl(getTemplatePictureFromLocal('img/flags/' + newLang + '.png'));
    } else {
      setFlagUrl(`${VPS_BASE_URL}/img/flags/${newLang}.png`);
    }

    await fetchAudioUrl(newLang);
    closeModalLanguage();
  };



  if (loading) {

    return (
      <LoadingView/>
    )
    
    
 
  }

  if (showPage === false) {

    return (
      <NoQrView/>
    )
    

  }

// ---SHOW PAGE----


// Handler to open allergy detail
const openAllergyDetail = (allergy) => {
  setSelectedAllergy(allergy);
};

// Handler to close allergy detail
const closeAllergyDetail = () => {
  setSelectedAllergy(null);
};

if (showPage) {
  return (
    <div className='page-content'>

      {/* Header Component */}
      <Header
        title={alert?.title}
        leftIcon={iconAssets?.warning}
        rightIcon={flagUrl}
        onRightIconClick={openModalLanguage}
      />

      {/* Main Card Content */}
      <div className='card-container'>
        {/* Allergy Grid */}
        <div className="allergy-list">
          <div
            className='allergy_list_containter'
            style={{ gridTemplateColumns: `repeat(${gridColumns}, 1fr)` }}
          >
            {allergies.map((item, index) => (
              <div className='allergy_item_wrapper' key={index}>
                {/* Clickable area for detail view */}
                <div
                  className='allergy_list_content'
                  onClick={() => openAllergyDetail(item)}
                >
                  <div className="img_container">
                    <img className='allergy_img' src={getAllergyImageUrl(item)} alt={item.name} />
                  </div>

                  <p className='allergy_title'>{item.translation}</p>
                  {userLanguageBrowser !== "en" && (
                    <p className='allergy_title_english'>{item.name}</p>
                  )}
                </div>

                {/* Speaker button - separate from detail click */}
                <button
                  className={`allergy_speaker_btn ${!item.audioUrl ? 'disabled' : ''}`}
                  onClick={(e) => {
                    e.stopPropagation();
                    if (item.audioUrl) {
                      playSound(item.audioUrl);
                    }
                  }}
                  disabled={!item.audioUrl}
                >
                  {iconAssets.speaker && (
                    <img className='allergy_speaker_icon' src={iconAssets.speaker} alt="Play sound" />
                  )}
                </button>
              </div>
            ))}
          </div>
        </div>

        {/* Separator line */}
        <div className="separator-line"></div>

        {/* Alert Text Section */}
        <div className='alert-text-section'>
          <p className='alert-text'>{alert?.text}</p>
        </div>

        {/* Bottom Action Bar */}
        <div className="action-bar">
          {/* Toggle Images Button */}
          <div className="action-item" onClick={toggleImageType}>
            <div className={`action-icon-circle ${showRealImages ? 'active' : ''}`}>
              {iconAssets.picture && (
                <img className="action-icon" src={iconAssets.picture} alt="Toggle" />
              )}
            </div>
            <span className="action-label">Switch to<br/>{showRealImages ? 'icons' : 'images'}</span>
          </div>

          {/* Language Button */}
          <div className="action-item" onClick={openModalLanguage}>
            <div className="action-icon-circle flag-circle">
              <img className="action-flag" src={flagUrl} alt="Flag" />
            </div>
            <span className="action-label">Tap to<br/>change language</span>
          </div>

          {/* Speaker Button */}
          <div
            className={`action-item ${!audioMain ? 'disabled' : ''}`}
            onClick={audioMain ? handlePlaySound : undefined}
          >
            <div className={`action-icon-circle ${!audioMain ? 'disabled' : ''}`}>
              {iconAssets.speaker && (
                <img className="action-icon" src={iconAssets.speaker} alt="Speaker" />
              )}
            </div>
            <span className="action-label">Tap to hear<br/>the text</span>
          </div>
        </div>

        {/* Footer integrated into card */}
        <div className="card-footer">
          <div className="card-footer-content">
            <img src={logo} alt="Food Allergy Card" className="card-footer-logo" />
            <div className="card-footer-download">
              <p>Download the app</p>
              <a href="https://play.google.com/store/apps/details?id=com.foodallergycard" target="_blank" rel="noopener noreferrer">
                <img src={playStoreLogo} alt="Play Store" className="card-footer-store" />
              </a>
              <a href="https://apps.apple.com/app/food-allergy-card/id6448350429" target="_blank" rel="noopener noreferrer">
                <img src={appStoreLogo} alt="App Store" className="card-footer-store" />
              </a>
            </div>
          </div>
          <p className="card-footer-copyright">&copy; {new Date().getFullYear()} Food Allergy Card. All rights reserved.</p>
        </div>
      </div>

      {showModalSelectLanguage && (
        <SelectLanguage
          title="Select Language"
          onClose={closeModalLanguage}
          onSelectLanguage={handleSelectLanguage}
          languages={languageList}
          userLanguageBrowser={userLanguageBrowser}
        />
      )}

      {/* Detail Allergy Modal */}
      {selectedAllergy && (
        <DetailAllergy
          allergy={selectedAllergy}
          title={alert?.title}
          userLanguageBrowser={userLanguageBrowser}
          flagUrl={flagUrl}
          iconAssets={iconAssets}
          showRealImages={showRealImages}
          onClose={closeAllergyDetail}
          onPlaySound={playSound}
          getAllergyImageUrl={getAllergyImageUrl}
        />
      )}
    </div>
  );
}






 
 



}

export default Body;
